export default {
  title: "Ship4Me Orders",
  subtitle: "Manage Ship4Me orders and shipping requests",
  
  addNew: "Add New Ship4Me Order",
  createOrder: "Create Ship4Me Order",
  editOrder: "Edit Ship4Me Order",
  deleteOrder: "Delete Ship4Me Order",
  orderDetails: "Ship4Me Order Details",
  viewOrder: "View Ship4Me Order",
  printInvoice: "Print Invoice",
  
  // Tabs for details page
  tabs: {
    editOrder: "Edit Order",
    statusUpdate: "Status Update",
    invoice: "Invoice",
    logs: "Logs",
    summaries: "Summaries",
    coreFormFields: "Core Form Fields",
    statusManagement: "Status Management",
    invoiceManagement: "Invoice Management",
    shipmentHistory: "Shipment History",
    shipmentSummary: "Shipment Summary"
  },
  
  // Fields
  fields: {
    orderNumber: "Order Number",
    orderGroup: "Group",
    customer: "Customer",
    merchantName: "Merchant Name",
    description: "Description",
    quantity: "Quantity",
    status: "Status",
    netPrice: "Net Price",
    servicePrice: "Service Price",
    voucherValue: "Voucher Value",
    weight: "Weight",
    width: "Width",
    height: "Height",
    length: "Length",
    trackingId: "Tracking ID",
    itemPrice: "Item Price",
    discount: "Discount",
    extraService: "Extra Service",
    totalPrice: "Total Price",
    totalPaid: "Total Paid",
    netDue: "Net Due",
    merchantDeliveryFee: "Merchant Delivery Fee",
    currency: "Currency",
    date: "Date",
    address: "Address",
    address2: "Address 2",
    phone: "Phone",
    carrier: "Carrier",
    orderPrice: "Order Price",
    createdAt: "Created At",
    updatedAt: "Updated At",
    originCountry: "Origin Country",
    destinationCountry: "Destination Country",
    shippingMethod: "Shipping Method",
    estimatedDelivery: "Estimated Delivery",
    link: "Link",
    itemOptions: "Item Options",
    extendedDescription: "Extended Description",
    paymentType: "Payment Type",
    category: "Category",
    unitWidth: "Unit Width",
    unitHeight: "Unit Height",
    unitLength: "Unit Length",
    unitWeight: "Unit Weight",
    itemType: "Item Type",
    deliveryMode: "Delivery Mode",
    shippingCompany: "Shipping Company",
    lbTransportPrice: "LB Transport Price",
    hasShippingInsurance: "Shipment Insurance",
    dgFees: "DG Fees",
    enableDGFees: "Enable DG Fees",
    city: "City",
    localDeliveryFee: "Local Delivery Fee",
    shippingOrderNumber: "Shipping Order Number",
    refundInvoiceNumber: "Refund Invoice Number",
    reorderedId: "Reordered Id",
    refundType: "Refund Type",
    additionalCost: "Additional Cost",
    initialPartialPayment: "Initial Partial Payment",
    orderStatus: "Order Status",
    comment: "Comment",
    currentStatus: "Current Status",
    paymentStatus: "Payment Status",
    paymentMethod: "Payment Method",
    shippingCompanyPricePerLB: "Shipping Company Price Per LB",
    enableLBPrice: "Enable LB Price",
    shippingInsurance: "Shipping Insurance",
    refundCode: "Refund Code",
    refundReceipt: "Refund Receipt",
    trackingNumber: "Tracking Number",
    flightNumber: "Flight Number",
    customsReference: "Customs Reference",
    courierName: "Courier Name",
    refundReference: "Refund Reference",
    lengthMeasurementUnit: "Length Unit",
    weightMeasurementUnit: "Weight Unit"
  },
  
  // Placeholders
  placeholders: {
    searchOrders: "Search Ship4Me orders...",
    selectCustomer: "Select Customer",
    enterMerchantName: "Enter merchant name",
    enterDescription: "Color, Size, any instructions",
    enterQuantity: "Enter quantity",
    enterWeight: "Enter weight (LB)",
    enterWidth: "Enter width (Inch)",
    enterHeight: "Enter height (Inch)",
    enterLength: "Enter length (Inch)",
    enterTrackingId: "Enter tracking ID",
    selectOriginCountry: "Select origin country",
    selectDestinationCountry: "Select destination country",
    selectShippingMethod: "Select shipping method",
    enterLink: "Enter product link",
    enterExtendedDescription: "Enter extended description",
    selectPaymentType: "Select Payment Type",
    selectCategory: "Select Category",
    selectShippingCompany: "Select Shipping Company",
    enterLbPrice: "Enter price per LB",
    enterComment: "Enter comment",
    enterItemPrice: "Enter item price",
    selectCurrency: "Select Currency",
    selectPaymentMethod: "Select Payment Method",
    enterMerchantDeliveryFee: "Enter merchant delivery fee",
    enterPricePerLB: "Enter price per LB",
    enterDgFees: "Enter DG fees",
    selectCity: "Select City",
    enterLocalDeliveryFee: "Enter local delivery fee",
    selectLengthUnit: "Select Length Unit",
    selectWeightUnit: "Select Weight Unit",
    enterInitialPartialPayment: "Enter initial partial payment amount",
    enterAdditionalCost: "Enter additional cost"
  },
  
  // Status options (same as orders but with Ship4Me context)
  statusOptions: {
    0: "Pending",
    1: "Validated",
    2: "Rejected",
    3: "Valid For Shipping",
    4: "Rejected By Shipping",
    5: "Calculated",
    6: "Approved",
    7: "Approved By Customer",
    8: "Rejected By Customer",
    9: "Payment Under Collecting",
    10: "Purchase Under Process",
    11: "On Hold",
    12: "Cancelled",
    13: "Order Purchased",
    14: "In Transit To Origin Warehouse",
    15: "Received At Origin Warehouse",
    16: "Lost/Damaged",
    17: "Delayed",
    18: "Refunded",
    19: "Reordered",
    20: "Shipped",
    21: "Arrived at Destination Country",
    22: "Under Customs Clearance",
    23: "Released From Customs",
    24: "Out For Delivery",
    25: "Delivered",
    26: "Delivery Failed",
    27: "Out For Delivery (Rescheduled)",
    28: "Returned To Sender",
    29: "Cancelled By Seller",
    30: "Refund Under Process",
    31: "Waiting To Receive Shipment",
    unknown: "Unknown Status"
  },

  // Payment type options
  paymentTypes: {
    0: "Cash on Delivery",
    1: "Partial Payment",
    2: "Advance Payment"
  },

  // Item type options
  itemTypes: {
    0: "Normal",
    1: "Dangerous"
  },

  // Delivery mode options
  deliveryModes: {
    0: "Economy",
    1: "Fast"
  },

  // Refund type options
  refundTypes: {
    0: "Please Select",
    1: "Cash",
    2: "Voucher"
  },

  // Extra field labels
  extraFieldLabels: {
    courierReceiptNo: "Courier Receipt No",
    orderNumber: "Order Number",
    shippingOrderNo: "Shipping Order No",
    reorderNumber: "Reorder Number",
    refundReceiptNo: "Refund Receipt No"
  },

  // Messages
  messages: {
    createSuccess: "Ship4Me order created successfully",
    createError: "Failed to create Ship4Me order",
    updateSuccess: "Ship4Me order updated successfully",
    updateError: "Failed to update Ship4Me order",
    deleteSuccess: "Ship4Me order deleted successfully",
    deleteError: "Failed to delete Ship4Me order",
    deleteConfirm: "Are you sure you want to delete this Ship4Me order?",
    statusUpdateSuccess: "Ship4Me order status updated successfully",
    statusUpdateError: "Failed to update Ship4Me order status",
    noOrders: "No Ship4Me orders found",
    loadingOrders: "Loading Ship4Me orders...",
    loading: "Loading Ship4Me order details...",
    fetchError: "Failed to fetch Ship4Me orders",
    orderNotFound: "Ship4Me order not found",
    noInvoices: "No invoices found.",
    noLogs: "No Logs found.",
    rejectedShipping: "Order has been rejected due to shipping reasons",
    rejected: "Order has been rejected",
    somethingWentWrong: "Something went wrong",
    failedToUpdate: "Failed to update order",
    failedToUpdateStatus: "Failed to update order status",
    orderUpdatedSuccessfully: "Order updated successfully!",
    orderUpdated: "Order updated successfully",
    updateFailed: "Failed to update order",
    orderCalculated: "Order calculated successfully",
    calculationFailed: "Failed to calculate order",
    orderReset: "Order reset successfully",
    resetFailed: "Failed to reset order",
    statusUpdated: "Status updated successfully",
    statusUpdateFailed: "Failed to update status"
  },
  
  // Actions
  actions: {
    view: "View",
    edit: "Edit",
    delete: "Delete",
    print: "Print",
    updateStatus: "Update Status",
    back: "Back to Ship4Me Orders",
    save: "Save Changes",
    cancel: "Cancel",
    refresh: "Refresh",
    calculateShipping: "Calculate Shipping",
    requestQuote: "Request Quote",
    updating: "Updating...",
    saveStatus: "Save Status",
    addNewInvoice: "Add New Invoice",
    validateOrder: "Validate Order",
    invalidateOrder: "Invalidate/Cancel Order",
    updateOrder: "Update Order",
    calculating: "Calculating...",
    calculateOrder: "Calculate Order",
    resetOrder: "Reset Order",
    confirm: "Confirm",
    calculate: "Calculate Shipping",
    virtualPartialCalculation: "Virtual Partial Calculation",
    partialPaymentValidationCalculation: "Partial Payment Validation & Calculation",
    applying: "Applying...",
    processing: "Processing...",
    apply: "Apply"
  },

  calculator: {
    title: "Ship4Me Shipping Calculator",
    subtitle: "Calculate shipping costs for Ship4Me orders"
  },

  form: {
    merchantDeliveryFee: "Merchant Delivery Fee"
  },
  
  // Table headers
  table: {
    orderNumber: "Order #",
    group: "Group",
    customer: "Customer",
    merchantName: "Merchant",
    quantity: "Qty",
    status: "Status",
    netPrice: "Net Price",
    actions: "Actions",
    originCountry: "Origin",
    destinationCountry: "Destination",
    shippingMethod: "Method",
    no: "No",
    amountFC: "Amount FC",
    amountIQD: "Amount IQD",
    collectionDate: "Collection Date",
    collected: "Collected?",
    received: "Received?",
    courierReceiptNo: "Courier Receipt No",
    paymentGateway: "Payment Gateway",
    user: "User",
    actionDate: "Action Date",
    log: "Log"
  },
  
  // Breadcrumbs
  breadcrumbs: {
    shipforme: "Ship4Me Orders",
    create: "Create Ship4Me Order",
    edit: "Edit Ship4Me Order",
    view: "Ship4Me Order Details"
  },
  
  // Sections
  sections: {
    merchantDetails: "Merchant Details",
    orderInfo: "Order Information",
    dimensions: "Dimensions",
    shippingTracking: "Shipping & Tracking",
    pricing: "Pricing Details",
    customerInfo: "Customer Information",
    orderHistory: "Order History",
    statusHistory: "Status History",
    shippingDetails: "Shipping Details",
    packageInfo: "Package Information",
    basicInformation: "Basic Information",
    locationAndCategory: "Location and Category",
    refundDetails: "Refund Details",
    productInformation: "Product Information",
    pricingQuantity: "Pricing & Quantity",
    locationShipping: "Location & Shipping",
    dimensionsWeight: "Dimensions & Weight",
    shippingOptions: "Shipping Options",
    extraInformation: "Extra Information"
  },
  
  // Units
  units: {
    lb: "LB",
    inch: "Inch",
    usd: "USD",
    iqd: "IQD",
    kg: "KG",
    cm: "CM"
  },
  
  // Validation
  validation: {
    linkRequired: "Link is required",
    linkInvalid: "Please enter a valid URL",
    merchantNameRequired: "Merchant name is required",
    merchantNameMinLength: "Merchant name must be at least 2 characters",
    descriptionRequired: "Item description is required",
    descriptionMinLength: "Description must be at least 3 characters",
    quantityRequired: "Quantity must be greater than 0",
    quantityMin: "Quantity must be at least 1",
    quantityMax: "Quantity cannot exceed 1000",
    itemPriceRequired: "Item price must be greater than 0",
    itemPriceMax: "Item price is too high",
    currencyRequired: "Please select a currency",
    weightRequired: "Weight must be greater than 0",
    weightMax: "Weight cannot exceed 1000 kg",
    widthRequired: "Width must be greater than 0",
    widthMax: "Width cannot exceed 1000 cm",
    heightRequired: "Height must be greater than 0",
    heightMax: "Height cannot exceed 1000 cm",
    lengthRequired: "Length must be greater than 0",
    lengthMax: "Length cannot exceed 1000 cm",
    dimensionsRequired: "Dimensions are required",
    originCountryRequired: "Please select origin country",
    destinationCountryRequired: "Please select destination country",
    categoryRequired: "Please select a category",
    shippingCompanyRequired: "Please select shipping company",
    pricePerLBRequired: "Price per LB is required when enabled",
    shippingMethodRequired: "Shipping method is required",
    paymentTypeRequired: "Please select payment type",
    allFieldsRequired: "All fields are required"
  },
  
  // Shipping methods
  shippingMethods: {
    air: "Air Freight",
    sea: "Sea Freight",
    land: "Land Transport",
    express: "Express Delivery",
    economy: "Economy Shipping",
    standard: "Standard Shipping"
  },

  // Summary section
  summary: {
    exchangePrice: "Exchange Price",
    choosenWeight: "Choosen Weight",
    shippingCost: "Shipping Cost",
    shippingInsurance: "Shipping Insurance",
    fuelCost: "Fuel Cost",
    tax: "Tax",
    shipForMeCost: "Ship For Me Cost",
    additionalCost: "Additional Cost",
    totals: "Totals",
    discount: "Discount",
    servicePrice: "Service Price",
    netPrice: "Net Price",
    locked: "Locked",
    fxLockTitle: "Locked Exchange Rate (at payment)",
    lockedRate: "USD/IQD Rate",
    rateSource: "Rate Source",
    lockedAt: "Locked At",
    roundingRule: "Rounding Rule"
  },

  // Modal translations
  modal: {
    compareChanges: "Compare Changes",
    previous: "Previous",
    current: "Current",
    confirmStatusChange: "Confirm Status Change",
    confirmPendingMessage: "Are you sure you want to set this order status to",
    confirmStatusChangeMessage: "Are you sure you want to change the status?",
    pending: "Pending",
    yesChange: "Yes, Change"
  },

  // Voucher approval translations
  voucherApproval: {
    title: "Voucher Refund Approval Required",
    message: "Do you confirm sending voucher to the customer with amount",
    approve: "Yes, Send Voucher",
    cancel: "Cancel",
    partialPaymentNote: "This amount represents the initial partial payment made by the customer."
  },
  common: {
    notCollected: "Not Collected",
    collected: "Collected",
    received: "Received",
    notReceived: "Not Received",
    no: "No",
    yes: "Yes"
  },

  // Customer Actions (Admin performing actions on behalf of customer)
  customerActions: {
    title: "Customer Actions (Admin)",
    description: "This order is awaiting customer approval. You can perform these actions on behalf of the customer.",
    applyVoucher: "Apply Voucher",
    voucherCode: "Voucher Code",
    enterVoucherCode: "Enter voucher code",
    voucherRequired: "Please enter a voucher code",
    voucherApplied: "Voucher applied successfully",
    voucherAppliedAmount: "Voucher Applied",
    voucherFailed: "Failed to apply voucher",
    approveReject: "Approve or Reject Order",
    approveRejectDescription: "Click one of the buttons below to approve or reject this order on behalf of the customer.",
    approve: "Approve Order",
    reject: "Reject Order",
    orderApproved: "Order approved on behalf of customer",
    orderRejected: "Order rejected on behalf of customer",
    statusChangeFailed: "Failed to change status"
  }
};
